import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

export default function GreetingGroup(props) {
  return (
    <Greeting>
      <Typography variant="h1" color="primary">
        {props.title}
      </Typography>
      <Typography variant="subtitle1" color="primary">
        {props.subtitle}
      </Typography>
    </Greeting>
  );
}

GreetingGroup.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

const Greeting = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px none;
`;
